module.exports = __webpack_public_path__ + "static/media/Pic-0429.d750037e.jpg";